export default "__VITE_ASSET__29e93f13__"